import { render } from "./Mitigationinfomodal.vue?vue&type=template&id=f13466da&scoped=true"
import script from "./Mitigationinfomodal.js?vue&type=script&lang=js"
export * from "./Mitigationinfomodal.js?vue&type=script&lang=js"

import "./Mitigationinfomodal.vue?vue&type=style&index=0&id=f13466da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f13466da"]])

export default __exports__